import { useState } from "react";

import { useToasts } from "app/common/hooks";
import { translate } from "app/filters/i18nFilter";
import RewardsModal from "app/pages/digital-suite/home-page/components/Rewards/RewardsModal";
import { getMemoizedRewardsOverview } from "app/pages/digital-suite/home-page/components/Rewards/utils/getRewardsModalData";
import type { IRewardsModal, IRewardsOverview } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";
import { allTrackers } from "app/services/track/track";
import { isDMITrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";

export const useRewardsModal = (): IRewardsModal => {
    const isEligibleUser = isDMITrialOrAfterTrial();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [rewardsOverview, setRewardsOverview] = useState<IRewardsOverview>();
    const { showErrorToast } = useToasts();

    const handleOpenModal = async () => {
        allTrackers.dispatchTrackEvent("Sidebar Interaction", "click", "settings and help/Referrals and rewards");
        setIsModalOpen(true);

        if (isEligibleUser) {
            const transformedData = await getMemoizedRewardsOverview();
            if (transformedData) {
                setRewardsOverview(transformedData);
            } else {
                setIsModalOpen(false);
                showErrorToast(translate("common.error"));
            }
        }
    };

    const handleClose = () => {
        setIsModalOpen(false);
    };

    const renderRewardsModal = () => (
        <RewardsModal
            isOpen={isModalOpen ? isEligibleUser : null}
            onClose={handleClose}
            invitations={rewardsOverview?.Invitations}
            packages={rewardsOverview?.Packages}
        />
    );

    return {
        rewardsModalComponent: renderRewardsModal(),
        handleOpenModal,
    };
};
